import { TagField } from "../../../components/others/TagField";
import { MoldeData } from "../../../services/Exams-Moldes/types";
import { Molde } from "../../../services/TurnServices/Turns.type";
import { PracticesLayout } from "./PracticesLayout";
import { PracticesList } from "./PracticesList";

export type MoldeDetailsProps = {
  molde: Molde | MoldeData;
};

export const MoldeDetails: React.FC<MoldeDetailsProps> = ({ molde }) => (
  <>
    <hr />
    {molde.exams.length > 0 && (
      <div className="flex flex-col max-w-lg">
        <span className="text-xs text-slate-600 my-3 ml-3">Exámenes:</span>
        <div className="flex flex-col max-w-lg">
          {molde.exams.map((exam) => (
            <div key={`m.e-${exam.id}`}>
              <div className="mb-6">
                <TagField className="bg-gray-200 font-bold">
                  {exam.name}
                </TagField>
              </div>
              <PracticesList
                practices={exam.practices}
                listContainerStyles="max-w-lg ml-2"
                listItemsStyles="mb-6 mr-2"
                keyPrefix="m.e.p-"
              />
            </div>
          ))}
        </div>
      </div>
    )}
    <hr />
    {molde.practices.length > 0 && (
        <PracticesLayout
          practices={molde.practices}
          listContainerStyles="max-w-lg"
          listItemsStyles="mb-6 mr-2"
          keyPrefix="m.p-"
        />
    )}
    <hr />
  </>
);
